// ═══════════════════════════════════════════════════════════════════
//  TOQUM · INSPECTION FORMAT SCHEMAS
//  Transcribed field-for-field from the J-Section workbook
//  (Tarasima Apparels Ltd. — Inspection Format List, Section J).
//  These ARE the ISO format register — there is no separate ISO tab;
//  each format below carries its own ISO number, subject and version.
// ═══════════════════════════════════════════════════════════════════

export const FORMAT_REGISTRY = [
  { sl:'01', code:'PPM',  iso:'BIT-TAL-QA-INS-RPT-J-01', subject:'Pre-Production Meeting',                   version:3, stage:'Pre-Production Meeting (PPM)' },
  { sl:'02', code:'MCP',  iso:'BIT-TAL-QA-INS-DOC-J-02', subject:'Manufacturing Control Plan (MCP)',         version:4, stage:'Manufacturing Control Plan (MCP)' },
  { sl:'03', code:'RISK', iso:'BIT-TAL-QA-INS-RPT-J-03', subject:'Risk Assessment and Preventive Action',    version:2, stage:'Risk Assessment & Preventive Action' },
  { sl:'04', code:'INSP', iso:'BIT-TAL-QA-INS-RPT-J-04', subject:'In-line / Pre-Final Inspection Report',    version:1, stage:'Inline / Pre-Final / Final Inspection' },
  { sl:'05', code:'FMEA', iso:'BIT-TAL-QA-INS-RPT-J-05', subject:'Failure Mode and Effects Analysis (FMEA)', version:1, stage:'FMEA Review & Closure' },
];

// ─────────────────────────────────────────────────────────────────
//  J-01 · PRE-PRODUCTION MEETING
// ─────────────────────────────────────────────────────────────────
export const PPM_PARTICIPANTS = [
  'GM / AGM (QAD)','Merchandiser','Unit HOD','Quality I/C','PM / APM (Prod)','Technician',
  'Quality Manager','CAD (Pattern)','I.E. Manager / Executive','Maintenance I/C',
  'Cutting Manager / Incharge','Auditor','Finishing Manager / Incharge','Line Chief',
  'Washing Responsible','Line QC','Sample Responsible','Line Supervisor',
  'GPQ Responsible','Fusing Responsible','Store Incharge','Fabric Manager / Incharge',
];

export const PPM_PLAN_ROWS = [
  { key:'cutting',       label:'Cutting' },
  { key:'input',         label:'Input' },
  { key:'output',        label:'Output' },
  { key:'washing',       label:'Washing' },
  { key:'finishing',     label:'Finishing' },
  { key:'packing',       label:'Packing' },
];
export const PPM_PILOT_ROWS = [
  { key:'pilotInitial',  label:'Pilot Run / Initial' },
  { key:'bulk1Sewing',   label:'1st Bulk — Sewing' },
  { key:'bulk2Finishing',label:'2nd Bulk — Finishing' },
  { key:'sewingInline',  label:'Sewing Inline' },
  { key:'finishingInline',label:'Finishing Inline' },
  { key:'preFinal',      label:'Pre-Final Inspection' },
  { key:'final',         label:'Final Inspection' },
];

export const PPM_FABRIC_ROWS = ['Shell','Pocketing','Contrast Fabric','Interlining','Marking Instruction for Sewing'];
export const PPM_FABRIC_COLS = [
  { label:'Description',      key:'description' },
  { label:'Content / Composition', key:'composition' },
  { label:'Consumption',      key:'consumption' },
  { label:'Total Qty Required', key:'required' },
  { label:'Total In-House Qty', key:'inhouse' },
  { label:'Balance Rcv Date',  key:'balanceDate', type:'date' },
  { label:'Remarks',           key:'remarks' },
];

export const PPM_FAB_INSPECTION = ['Fabric Inspection','Reject Qty','CSV','Shrinkage Control','Shade Check'];
export const PPM_SHRINKAGE = ['Shrinkage to Steam','Shrinkage to Washing','Shrinkage to Fusing Condition','Pattern Shrinkage'];

export const PPM_THREAD_ROWS = ['Thread Ticket','Thread Count','Pocket','SPI'];
export const PPM_THREAD_COLS = [
  { label:'Process',   key:'process' },
  { label:'Top Sewing — Top', key:'topTop' },
  { label:'Top Sewing — Bobbin', key:'topBobbin' },
  { label:'Overlock — Chain', key:'olChain' },
  { label:'Overlock — 3 Thread', key:'ol3' },
  { label:'Bartack/Hole — Upper', key:'btUpper' },
  { label:'Bartack/Hole — Lower', key:'btLower' },
  { label:'Remarks',   key:'remarks' },
];

export const PPM_SAMPLE_APPROVALS = [
  'Counter Sample Approval','P.P. Sample Approval','Tag Sample Approval',
  'Size Set Approval','Update SPEC Approval',
];

export const PPM_LAYERING = [
  'Lay height (inch)','Blocking & relay on pins','Edge cutting by machine','Relaxation after laying',
  'Laying on pins','Tension free','Face up','Major defects to be removed','Face down',
  'Twill direction "z"','Nap down (as sample)','Twill direction "s"','Nap up','One garment one way',
  'Lot Nos. to be followed','Cut Plan',
];

export const PPM_FUSING_COLS = [
  { label:'Fabric Color', key:'fabricColor' }, { label:'Fusing Parts', key:'parts' },
  { label:'Fusing Color', key:'fusingColor' }, { label:'Fusing Type', key:'type',
    type:'select', options:['Normal fusing','Dotted fusing','Cotton fusing','Trycord fusing'] },
  { label:'Temp (°C)', key:'temp' }, { label:'Pressure', key:'pressure' },
  { label:'Timing (sec)', key:'timing' }, { label:'Bonding Strength', key:'bonding' },
];

export const PPM_MACHINE_TYPES = ['S/N','D/N','C/S','FOA','KSP','O/L','BTK','BT/H','E/H','B/S','F/L','Others'];

export const PPM_CT_COLS = [
  { label:'Attributes', key:'attribute' }, { label:'Risk', key:'risk' },
  { label:'Action', key:'action' }, { label:'Responsible', key:'responsible' },
];

export const PPM_PACK_ACCESSORIES = ['Hang Tag','Price Ticket','Button / Rivet','Size Tape','Hanger','Sizer','Waist Tag','Poly Bag'];

export const PPM_HOME_TESTS = [
  { group:'Colour Fastness to Washing', rows:[
    { criteria:'Colour Change',  required:'4' }, { criteria:'Cross Staining', required:'4-5' },
    { criteria:'Colour Staining', required:'4' } ] },
  { group:'Colour Fastness to Rubbing', rows:[
    { criteria:'Wet', required:'4' }, { criteria:'Dry', required:'3' } ] },
  { group:'Print Fastness', rows:[
    { criteria:'Wet', required:'4' }, { criteria:'Dry', required:'4' } ] },
  { group:'Appearance After Washing', rows:[
    { criteria:'Colour Change', required:'4' }, { criteria:'Cross Staining', required:'4-5' } ] },
  { group:'Dimensional Stability to Washing', rows:[
    { criteria:'Warp', required:'+/-5%' }, { criteria:'Weft', required:'+/-5%' } ] },
  { group:'Tear Strength', rows:[
    { criteria:'Warp', required:'10N' }, { criteria:'Weft', required:'10N' } ] },
  { group:'Fabric Weight After Wash', rows:[
    { criteria:'GSM', required:'+/-5%' } ] },
];

// ─────────────────────────────────────────────────────────────────
//  J-02 · MANUFACTURING CONTROL PLAN (MCP)
// ─────────────────────────────────────────────────────────────────
export const MCP_COLS = [
  { label:'Controlled Process',   key:'controlledProcess', type:'textarea', width:'150px' },
  { label:"Type (What's Controlled)", key:'type', type:'textarea', width:'140px' },
  { label:'Specification Limit',  key:'specLimit', type:'textarea', width:'160px' },
  { label:'Measurement Method',   key:'measurementMethod', type:'textarea', width:'130px' },
  { label:'Control Method',       key:'controlMethod', type:'textarea', width:'180px' },
  { label:'Sample Size',          key:'sampleSize', width:'100px' },
  { label:'Frequency',            key:'frequency', width:'120px' },
  { label:'Process Completed By', key:'completedBy', width:'120px' },
  { label:'Doc Control Ref',      key:'docRef', width:'120px' },
  { label:'Decision Role',        key:'decisionRole', width:'120px' },
  { label:'Applicability',        key:'applicability', type:'select', options:['Mandatory','Optional','N/A'], width:'100px' },
];

// Default MCP rows carried over from the reference plan — editable per style.
export const MCP_STEPS = [
  { step:'Process Monitoring & Planning', rows:[
    { controlledProcess:'Production Planning', type:'Only 1 shift', specLimit:'Based on IE calculation',
      measurementMethod:'Per hour capacity of Cutting, Sewing & Finishing/Packing',
      controlMethod:'Production line allocation based on ship-date target and monitored accordingly',
      frequency:'Every PO before production start', completedBy:'Production Head, Planning Mgr, IE Mgr', applicability:'Mandatory' },
    { controlledProcess:'Develop MCP', type:'Product category wise', specLimit:'Monitoring, Inspection & Testing',
      controlMethod:'MCP written per product category and product risk',
      frequency:'Per product category', completedBy:'Quality Manager', applicability:'Mandatory' },
    { controlledProcess:'Size Set', type:'Based on red seal & fit comments',
      specLimit:'Evaluation — construction, workmanship & measurement',
      sampleSize:'2 pcs each colour each size', frequency:'Every new style or colour change', completedBy:'Quality Manager', applicability:'Mandatory' },
    { controlledProcess:'Trial Run (Initial) Evaluation', type:'Styling / PP / fit / TPR comments review',
      specLimit:'Evaluation — construction, workmanship & measurement',
      frequency:'After PP meeting, before bulk', completedBy:'GPQ + P&D team', applicability:'Mandatory' },
    { controlledProcess:'Pre-Production Meeting', type:'All departments — product overview, historical data, risk',
      controlMethod:'Historical data, DHU%, Eff%, top 3 defects of FRI reviewed',
      frequency:'Every new style before production', completedBy:'Quality Incharge, GPQ', applicability:'Mandatory' },
    { controlledProcess:'Critical To Quality & Critical To Process', type:'Process-wise CTQ/CTP points',
      measurementMethod:'Inspection (Manual & Visual)', frequency:'Every new style before production',
      completedBy:'Quality Incharge, GPQ', applicability:'Mandatory' },
    { controlledProcess:'Critical To Safety', type:'Safety-critical process points',
      measurementMethod:'Inspection, machine (manual & visual)',
      controlMethod:'Risk level High — detailed action plan attached in CTS form',
      frequency:'Every new style before production', completedBy:'Quality Incharge, GPQ', applicability:'Mandatory' },
    { controlledProcess:'First Piece Output Inspection vs Approved Sample', type:'Styling / PP / fit / TPR review',
      specLimit:'Evaluation — construction, workmanship & measurement',
      frequency:'First output of every line', completedBy:'Floor concern + GPQ', applicability:'Mandatory' },
  ]},
  { step:'Raw Material Received (Inspection) — Warehouse', rows:[
    { controlledProcess:'Goods Received', type:'As per PI & packing list', measurementMethod:'Monitoring & manual',
      controlMethod:'Goods received and stored in quarantine area on plate', sampleSize:'Every lot',
      frequency:'Each receipt of raw materials', completedBy:'Executive (Store)', docRef:'Physical Check', applicability:'Mandatory' },
    { controlledProcess:'Mass Summary — verify received goods & inventory',
      type:'Check incoming materials against GRS, TC, PI, PO, packing list & specification',
      controlMethod:'Claim materials stored separately in rack; records maintained raw material to shipment',
      frequency:'Daily', completedBy:'Store / QA', applicability:'Mandatory' },
    { controlledProcess:'Inspected Goods Segregation', measurementMethod:'Monitoring pass, fail & waiting for approval',
      controlMethod:'Pass (Green Zone), Fail (Red Zone), Waiting approval (Yellow Zone)',
      frequency:'Each receipt after inspection', completedBy:'Accessories Inspector', applicability:'Mandatory' },
    { controlledProcess:'Fail Goods to Non-Conforming Area', measurementMethod:'Monitoring & manual',
      controlMethod:'Kept in non-conforming area with record; supplier informed to ensure re-supply',
      frequency:'Every failed inspection', completedBy:'QA Executive, Store Manager, Merchandiser', applicability:'Mandatory' },
    { controlledProcess:'Hanging Bin Card', measurementMethod:'Monitoring & manual',
      controlMethod:'Ensures traceability — item, style, PO, qty', frequency:'All storage goods',
      completedBy:'Executive (Store)', applicability:'Mandatory' },
    { controlledProcess:'Fabric Relaxation',
      specLimit:'Knit roll 24 hrs · Knit flat 12 hrs · Stretch 24 hrs · Woven 6 hrs',
      measurementMethod:'Visual & manual', sampleSize:'100% before cutting',
      frequency:'All fabric before cutting', completedBy:'Executive (Store)', applicability:'Mandatory' },
    { controlledProcess:'Shade Check Under Light Box', type:'Shade check',
      specLimit:'As per buyer-approved light source',
      controlMethod:'Check in light box UL3500 (primary) & D65 (secondary); segregate matching shade groups',
      frequency:'Every batch & roll', completedBy:'Fabric Inspector', applicability:'Mandatory' },
    { controlledProcess:'Fabric Inspection', specLimit:'24 points per 100 sq yds — 4 Point System',
      measurementMethod:'Visual inspection, manual & measurement',
      sampleSize:'Min 10% per batch per colour (new supplier min 20%)',
      frequency:'Each receipt of incoming fabric, all colours', completedBy:'Fabric Inspector', applicability:'Mandatory' },
    { controlledProcess:'Trims & Accessories Inspection', type:'Countable & uncountable',
      specLimit:'Countable AQL 1.5 L-1 · Non-countable 4 Point System',
      measurementMethod:'Visual inspection & manual', frequency:'Each lot',
      completedBy:'Accessories Inspector', applicability:'Mandatory' },
    { controlledProcess:'Fabric Shrinkage & Distortion Test', specLimit:'Fabric −7% / +7% · Distortion ±3%',
      measurementMethod:'Shrinkage template 60×60 cm marked 50×50 cm',
      frequency:'Colour-wise per lot', completedBy:'Lab Technician', applicability:'Mandatory' },
    { controlledProcess:'Metal Detection Scan', specLimit:'No tolerance — must be sorted out',
      measurementMethod:'Metal detector machine',
      controlMethod:'Machine calibrated by ferrous test card 1.2 mm before passing trims',
      sampleSize:'10% metal detection for specified items', frequency:'Each & every lot',
      completedBy:'Metal Detector Operator', docRef:'BIT-TAL-QA-FIN-RPT-G-12', applicability:'Mandatory' },
    { controlledProcess:'GSM Check', specLimit:'Acceptable +10% / −5%', measurementMethod:'Visual & weight',
      controlMethod:'GSM cut from beginning, middle and end of each roll with GSM cutter and weighed',
      frequency:'Each consignment', completedBy:'Lab Technician', applicability:'Mandatory' },
  ]},
  { step:'Cutting', rows:[
    { controlledProcess:'Pattern Check', specLimit:'No tolerance', measurementMethod:'Manual & measurement',
      controlMethod:'Correct pattern prepared for measurement control in final product',
      sampleSize:'Once before supply to production', frequency:'Before supply to production',
      completedBy:'Cutting QC', applicability:'Mandatory' },
    { controlledProcess:'Marking', type:'Computer marker', measurementMethod:'Visual & measurement',
      controlMethod:'CAD marking for print/solid fabric; manual marking only for stripe fabric',
      sampleSize:'Each marker', frequency:'Before each cutting', completedBy:'CAD Marker & Marker Man', applicability:'Mandatory' },
    { controlledProcess:'Spreading', specLimit:'3–4 inch lay height maintained per SOP',
      measurementMethod:'Manual, visual & measurement', frequency:'Each lay', completedBy:'Spreader', applicability:'Mandatory' },
    { controlledProcess:'Cutting', specLimit:'Keep end bits from each roll, shade segregation, proper relaxation',
      measurementMethod:'Manual, visual & measurement', frequency:'Based on order quantity cutting no.',
      completedBy:'Cutter Man', applicability:'Mandatory' },
    { controlledProcess:'Replace of Non-Conforming Cut Components', measurementMethod:'Manual / visual',
      controlMethod:'Non-conforming components disposed and replaced', sampleSize:'100% replace',
      completedBy:'Asst. Cutting', docRef:'Cut Panel Replacement Report', applicability:'Mandatory' },
    { controlledProcess:'Sharp Tools Control', specLimit:'Daily issue & receive register',
      measurementMethod:'Manual / visual', frequency:'Twice a day — issue & receive',
      completedBy:'Cutting Incharge', applicability:'Mandatory' },
    { controlledProcess:'Marker Check', specLimit:'No tolerance', measurementMethod:'Manual & measurement',
      sampleSize:'100% marker check', frequency:'Each drawing during marking',
      completedBy:'Cutting Quality Inspector', docRef:'BIT-TAL-QA-CUT-RPT-C-01', applicability:'Mandatory' },
    { controlledProcess:'Cutting Accuracy Check', specLimit:'Tolerance −2 mm / +3 mm',
      measurementMethod:'Manual, visual & measurement',
      controlMethod:'10% random check from top, middle and bottom lay — major components',
      sampleSize:'Top, middle, bottom (3 pcs)', completedBy:'Cutting Quality Inspector', applicability:'Mandatory' },
    { controlledProcess:'100% Cut Panel Inspection', type:'Fabric fault and other defects',
      measurementMethod:'Visual & measurement', sampleSize:'100% cutting block (big parts)',
      frequency:'Against each cutting', completedBy:'Cutting Quality Inspector', applicability:'Mandatory' },
    { controlledProcess:'Printing Quality Check', specLimit:'As per approved print panel',
      measurementMethod:'Visual & measurement', sampleSize:'100% of printed panels',
      frequency:'Print panel wash test — one per day', completedBy:'Outsource (Tier 2) + Cutting QI', applicability:'Optional' },
    { controlledProcess:'Embroidery Quality Check', specLimit:'As per approved embroidery panel',
      measurementMethod:'Visual & measurement', sampleSize:'100% of embroidered panels',
      frequency:'Before supply to production', completedBy:'Outsource (Tier 2) + Cutting QI',
      docRef:'BIT-TAL-QA-PRI/EMB', applicability:'Optional' },
    { controlledProcess:'Fusing Machine Calibration (Temp, Pressure, Time)', specLimit:'As per supplier data sheet',
      controlMethod:'140–170 °C, 14–18 sec, 1.50–2.50 kg pressure; visual inspection for evenness',
      frequency:'Twice per day for each running fusing machine', completedBy:'Safety Inspector', applicability:'Mandatory' },
    { controlledProcess:'Fusing Bonding Strength Check', specLimit:'Requirement 500–600 gm',
      measurementMethod:'Bonding strength check machine', sampleSize:'3 pcs per report',
      frequency:'Twice per day for every running style', completedBy:'Safety Inspector',
      docRef:'BIT-TAL-QA-CUT', applicability:'Mandatory' },
    { controlledProcess:'Heat Seal Inspection', type:'Letter visibility, broken letter, shade, placement',
      measurementMethod:'Visual & measurement', controlMethod:'170–185 °C, 15–20 sec, 3–4 kg pressure',
      sampleSize:'Up to 150 — sample 20 pcs', completedBy:'Safety Inspector', applicability:'Optional' },
  ]},
  { step:'Sewing (Input — Output Activities)', rows:[
    { controlledProcess:'Input Monitoring', type:'Sewing input',
      specLimit:'Max 1 day production capacity to avoid huge WIP',
      measurementMethod:'Monitoring & manual',
      controlMethod:'Input from cutting by proper challan; mass balance record maintained',
      frequency:'Daily', completedBy:'Line Supervisor', applicability:'Mandatory' },
    { controlledProcess:'Traceability Number',
      type:'Sealed with cut number, fabric batch number and shade',
      controlMethod:'Traceability measured by picking semi-finished or finished garment with bundle number',
      frequency:'Every bundle', completedBy:'Line Supervisor', applicability:'Mandatory' },
    { controlledProcess:'Output Monitoring',
      specLimit:'End-line hourly production = QC pass production, matched size-wise to input',
      measurementMethod:'Monitoring & manual', frequency:'Hourly', completedBy:'Line Supervisor', applicability:'Mandatory' },
    { controlledProcess:'Non-Conforming Complete Garments',
      controlMethod:'Rejection goods segregated end of day by quality head with traceability',
      frequency:'Daily', completedBy:'Quality Head', applicability:'Mandatory' },
    { controlledProcess:'Machine Setting', specLimit:'As per IE operation bulletin layout',
      frequency:'Each machine per layout & maintenance schedule', completedBy:'Mechanic / IE', applicability:'Mandatory' },
    { controlledProcess:'Needle Point Check', measurementMethod:'Manual / visual',
      controlMethod:'Each machine checked with lycra fabric before start', sampleSize:'Each machine',
      frequency:'Daily 2 times', completedBy:'Operator', applicability:'Mandatory' },
    { controlledProcess:'Sharp Tools Control', specLimit:'Daily issue & receive register',
      frequency:'Twice a day', completedBy:'Line Supervisor', applicability:'Mandatory' },
    { controlledProcess:'Needle Control',
      specLimit:'Needle used as per R&D chart; changes decided by R&D',
      controlMethod:'Handling broken needles, needle exchange, prevention of metal contamination',
      frequency:'Every broken needle', completedBy:'Line Supervisor / Store', applicability:'Mandatory' },
    { controlledProcess:'Mock-up of Operation',
      specLimit:'Process mock-up approved by QC incharge with operator acknowledgement',
      controlMethod:'Sewing sequence-wise samples hung at every machine (inside & outside view)',
      frequency:'Every new style', completedBy:'QC Incharge', applicability:'Mandatory' },
    { controlledProcess:'Machine Oil Check', measurementMethod:'Monitoring & manual',
      controlMethod:'Ensure no oil leakage from machine', sampleSize:'Every machine',
      frequency:'Daily', completedBy:'Line QC', docRef:'BIT-TAL-QA-SEW-RPT-E-09', applicability:'Mandatory' },
    { controlledProcess:'SPI Check', specLimit:'Top stitch 7 (+2/−1) · Seams & others 11 (+2/−1)',
      measurementMethod:'Manual / visual measure', frequency:'Two times a day',
      completedBy:'Line QC', docRef:'Mockup Check for SPI', applicability:'Mandatory' },
    { controlledProcess:'Traffic Light Check',
      specLimit:'Green = no defect · Yellow = 1 defect · Red = 2+ defects',
      measurementMethod:'Manual / visual measure', sampleSize:'7 pcs / bundle at random',
      frequency:'Hourly per process', completedBy:'Inline QC', applicability:'Mandatory' },
    { controlledProcess:'Machine Stop', specLimit:'As per 7 pcs inspection result',
      controlMethod:'2+ faults during traffic light → bundle rejected, machine stopped and recorded',
      completedBy:'Line QC & QI', applicability:'Mandatory' },
    { controlledProcess:'In-Line Critical Process Quality Check',
      type:'Critical points per style (action plan in CTQ report & risk assessment)',
      measurementMethod:'Manual / visual measure', sampleSize:'100% semi-finished garments',
      frequency:'Hourly', completedBy:'In-process QC', applicability:'Mandatory' },
    { controlledProcess:'End-line 100% Garment Check + 5% Key Measurement Check',
      specLimit:'No tolerance — must be sorted out and repaired',
      measurementMethod:'Manual / visual measure', sampleSize:'100% output',
      frequency:'Hourly', completedBy:'End-line QC', applicability:'Mandatory' },
    { controlledProcess:'Lot Pass', specLimit:'AQL 1.5 Level-I', measurementMethod:'Manual / visual measure',
      sampleSize:'Based on AQL 1.5', frequency:'Random on end-line passed garments',
      completedBy:'Line QA', docRef:'BIT-TAL-QA-SEW-RPT-E-12', applicability:'Mandatory' },
    { controlledProcess:'Pinch Setting / Button Pull Test', specLimit:'Pull force 6.8 lb; pinch total 2.40 mm ±10 mm',
      measurementMethod:'Slide calipers, pull test machine', sampleSize:'2–5 pcs per buyer requirement',
      frequency:'As per buyer requirement', completedBy:'Safety Inspector', applicability:'Optional' },
  ]},
  { step:'Pressing, Finishing & Packing', rows:[
    { controlledProcess:'Input Shade Checking (denim)', specLimit:'Lot wise — failed lot returned to washing plant',
      controlMethod:'Garments checked against buyer approved shade at AQL 1.5 (L-II)',
      frequency:'Each lot', completedBy:'Quality Inspector', applicability:'Optional' },
    { controlledProcess:'Inline Quality Check',
      type:'100% garments checked inside and outside for washing, sewing & fabric defects',
      measurementMethod:'Manual / visual', sampleSize:'100% garments',
      frequency:'Each style, each colour', completedBy:'Finishing QI', applicability:'Mandatory' },
    { controlledProcess:'Pinch Setting, Pull Test & Bingo Card', specLimit:'Pull force 6.8 lb',
      measurementMethod:'Slide calipers, pull test machine', sampleSize:'2–5 pcs',
      frequency:'As per buyer requirement', completedBy:'Safety Inspector', applicability:'Optional' },
    { controlledProcess:'Measurement Checking', specLimit:'Following customer tolerance chart',
      measurementMethod:'Calibrated measurement tape or steel scale', sampleSize:'100% goods',
      frequency:'Against each style', completedBy:'Measurement QI', applicability:'Mandatory' },
    { controlledProcess:'End-line Quality Check',
      type:'Defective garments returned to sewing line for alteration',
      measurementMethod:'Manual / visual', sampleSize:'100% garments at top & inside after thread trimming',
      completedBy:'Finishing QI', applicability:'Mandatory' },
    { controlledProcess:'Finishing Shade Segregation',
      specLimit:'One shade in carton as per approved shade passing',
      sampleSize:'Each colour & style 100%', completedBy:'Quality Inspector', applicability:'Mandatory' },
    { controlledProcess:'SKU Check', specLimit:'No tolerance', measurementMethod:'Approved trims card & file',
      controlMethod:'Ensures right accessories attached in correct position',
      sampleSize:'Each colour & style 100% garments', completedBy:'Quality Inspector',
      docRef:'BIT-TAL-QA-FIN-RPT-G-10', applicability:'Mandatory' },
    { controlledProcess:'Finishing Audit', specLimit:'AQL 1.5 Level-I', measurementMethod:'Manual / visual',
      controlMethod:'Visual check for 100% AQL qty + measurement 2 pcs per lot before carton packing',
      sampleSize:'Lot audit AQL 1.5 L-1', completedBy:'Line QA',
      docRef:'BIT-TAL-QA-FIN-RPT', applicability:'Mandatory' },
    { controlledProcess:'Sharp Tools Control', specLimit:'Daily issue & receive register',
      frequency:'Twice a day', completedBy:'Finishing Incharge', applicability:'Mandatory' },
    { controlledProcess:'Mould / Moisture Control',
      specLimit:'Cotton 8% · Nylon 4% · Polyester 0.04% · Viscose 12.30% · Wool 16% · Carton 6–8%',
      controlMethod:'Plastic coated pallets to stack fabrics with poly',
      frequency:'Continuous', completedBy:'Finishing QI', applicability:'Mandatory' },
    { controlledProcess:'Pass by Metal Detector',
      specLimit:'Hourly calibration through 9 point system; sensitivity 1.2 mm',
      measurementMethod:'Manual / visual', frequency:'Hourly calibration',
      completedBy:'Metal Detector Operator', applicability:'Mandatory' },
    { controlledProcess:'Packing Accuracy Check', specLimit:'Based on size & quantity',
      measurementMethod:'Manual / visual measure',
      controlMethod:'Shipping marks, carton dimension, carton standard, packing sequence, ratio',
      frequency:'Each PO during packing', completedBy:'Finishing QI',
      docRef:'BIT-TAL-QA-FIN-RPT-G-14', applicability:'Mandatory' },
    { controlledProcess:'Pre-Final Check', specLimit:'As per AQL', measurementMethod:'Manual / visual measure',
      controlMethod:'Pre-final inspection after garments 80–100% packed from all colours & sizes',
      frequency:'Each PO', completedBy:'Quality Assurance Department', applicability:'Mandatory' },
    { controlledProcess:'Top of Production Test (External)', specLimit:'As per client requirements',
      frequency:'Every colour & style, every 12 months', completedBy:'Buyer nominated lab', applicability:'Optional' },
    { controlledProcess:'ORT (On-going Random Test)', specLimit:'As per client requirements',
      frequency:'Every colour & style, every 3 months', completedBy:'Buyer nominated lab', applicability:'Optional' },
  ]},
  { step:'Shipping', rows:[
    { controlledProcess:'Storage of Complete Cartons in CTPAT Area',
      specLimit:'Kept 15 cm from wall on pallet with traceability', measurementMethod:'Manual / visual',
      sampleSize:'All complete cartons', completedBy:'FG Incharge', applicability:'Mandatory' },
    { controlledProcess:'Cargo / Container Loading under CTPAT Area', specLimit:'Loading under roof shade',
      controlMethod:'Covered van kept in secure area under CCTV surveillance',
      frequency:'Each container', completedBy:'FG Incharge', applicability:'Mandatory' },
    { controlledProcess:'Cargo / Container Sealing',
      specLimit:'High-voltage security seal; images captured empty, middle and final sealed stage',
      frequency:'Every container', completedBy:'Security / FG', applicability:'Mandatory' },
    { controlledProcess:'7 Point Cargo / Container Inspection',
      specLimit:'7 point system during carton loading; 9 point hole checking',
      measurementMethod:'Inspection (manual & visual)',
      controlMethod:'Outside/undercarriage, inside & outside doors, right, left, front wall, ceiling, floor',
      frequency:'Every container', completedBy:'Security Officer', applicability:'Mandatory' },
  ]},
];

// MCP — Wash variant (J-02 Wash)
export const MCP_WASH_STEPS = [
  { step:'Laundry — Before Wash Quality Check', rows:[
    { controlledProcess:'Before Wash Quality Check',
      type:'Shade variation + safety stitch, over stitch, zipper damage, pocket corner damage, spot',
      specLimit:'Based on AQL', measurementMethod:'Visual checking',
      controlMethod:'Highlight potential risk and discuss with concerned', applicability:'Mandatory' },
  ]},
  { step:'Laundry (Wet Process)', rows:[
    { controlledProcess:'Enzyme, Bleach, Softener, Acid', specLimit:'100 kg per batch',
      measurementMethod:'Shade check under the water house',
      controlMethod:'Garments washed as per final wash recipe', sampleSize:'Randomly check',
      frequency:'Every batch', completedBy:'Operator / Production Supervisor',
      docRef:'Washing Recipe', applicability:'Mandatory' },
    { controlledProcess:'Hydro Extraction', type:'Garment stability', specLimit:'Should be 75% of extraction',
      controlMethod:'Maintaining time cycle to keep control', sampleSize:'Per batch 100 kg',
      frequency:'Every batch', completedBy:'Operator / Production Supervisor', applicability:'Mandatory' },
    { controlledProcess:'Dryer', type:'Garment dimension and stability',
      specLimit:'Temperature not more than 60–70 °C',
      controlMethod:'Maintaining time cycle to keep spec under control', sampleSize:'Per batch 100 kg',
      frequency:'Every batch', completedBy:'Operator / Production Supervisor', applicability:'Mandatory' },
  ]},
  { step:'Laundry (Dry Process)', rows:[
    { controlledProcess:'Grinding', specLimit:'Follow the approved sample', measurementMethod:'Grinding measurement',
      sampleSize:'Every garment', frequency:'100% garments', completedBy:'Dry Process Quality Controller',
      docRef:'BIT-TAL-QA-WAS-RPT-F-04', applicability:'Mandatory' },
    { controlledProcess:'Destroy / Tearing', specLimit:'Follow the approved sample', measurementMethod:'Tearing measurement',
      sampleSize:'Every garment', frequency:'100% garments', completedBy:'Dry Process Quality Controller',
      docRef:'BIT-TAL-QA-WAS-RPT-F-04', applicability:'Mandatory' },
    { controlledProcess:'Tagging', specLimit:'Follow the approved sample', measurementMethod:'Tagging design',
      sampleSize:'Every garment', frequency:'100% garments', completedBy:'Dry Process Quality Controller',
      docRef:'BIT-TAL-QA-WAS-RPT-F-04', applicability:'Mandatory' },
    { controlledProcess:'Whisker', specLimit:'Follow the approved sample', measurementMethod:'Whisker pattern design',
      sampleSize:'Every garment', frequency:'100% garments', completedBy:'Dry Process Quality Controller',
      docRef:'BIT-TAL-QA-WAS-RPT-F-04', applicability:'Mandatory' },
    { controlledProcess:'Hand Sanding', specLimit:'Follow the approved sample', measurementMethod:'Hand sanding measurement',
      sampleSize:'Every garment', frequency:'100% garments', completedBy:'Dry Process Quality Controller',
      docRef:'BIT-TAL-QA-WAS-RPT-F-04', applicability:'Mandatory' },
  ]},
  { step:'Laundry (Final Quality Check)', rows:[
    { controlledProcess:'Shade and Quality Check (Risk Point)',
      specLimit:'Checked against approved shade band for shade and quality',
      measurementMethod:'Visual check as per approved shade range',
      controlMethod:'Compare with approved standard under correct light source; maintain records',
      sampleSize:'100% check after dryer', frequency:'100% garments', applicability:'Mandatory' },
  ]},
  { step:'Laundry (Lab Test)', rows:[
    { controlledProcess:'pH Test', specLimit:'pH requirement 5.5 to 9', measurementMethod:'pH tester reading',
      controlMethod:'High pH controlled with acetic acid; low pH with sodium bicarbonate',
      sampleSize:'Randomly 1 pc', frequency:'Every batch', completedBy:'Lab Technician',
      docRef:'TAL/QA/LAB-01', applicability:'Mandatory' },
    { controlledProcess:'Tearing Test', specLimit:'Tearing requirement 5.5 × 4 LBF',
      measurementMethod:'Tearing tester reading', controlMethod:'Controlled by tearing improver agent',
      sampleSize:'Randomly 1 pc', frequency:'Every batch', completedBy:'Lab Technician',
      docRef:'TAL/QA/LAB-01', applicability:'Mandatory' },
    { controlledProcess:'Tensile Test', specLimit:'Tensile requirement 90 × 50 LBF',
      measurementMethod:'Tensile tester reading', controlMethod:'Controlled by tensile agent & wash recipe change',
      sampleSize:'Randomly 1 pc', frequency:'Every batch', completedBy:'Lab Technician',
      docRef:'TAL/QA/LAB-01', applicability:'Mandatory' },
  ]},
];

// ─────────────────────────────────────────────────────────────────
//  J-03 · RISK ASSESSMENT AND PREVENTIVE ACTION
// ─────────────────────────────────────────────────────────────────
export const RISK_DEPARTMENTS = [
  'Sampling, CAD & Pattern','Maintenance','Fabric Store','Cutting','Sewing',
  'Washing','Finishing & Packing','Quality Assurance','Store / Trims',
];
export const RISK_COLS = [
  { label:'Section / Department', key:'department', type:'select', options:RISK_DEPARTMENTS, width:'130px' },
  { label:'Process',             key:'process', width:'130px' },
  { label:'Potential Issue',     key:'issue', type:'textarea', width:'150px' },
  { label:'Preventive Action Plan', key:'action', type:'textarea', width:'240px' },
  { label:'Responsible',         key:'responsible', width:'130px' },
  { label:'Target Date',         key:'targetDate', type:'date', width:'110px' },
  { label:'Status',              key:'status', type:'select', options:['Open','In Progress','Closed'], width:'100px' },
];

// ─────────────────────────────────────────────────────────────────
//  J-04 · IN-LINE / PRE-FINAL INSPECTION REPORT
// ─────────────────────────────────────────────────────────────────
export const INSP_CHECK_SECTIONS = {
  'Cutting':   ['Woven','Pattern','Marker','Stripe Match','Cutting Reports','Shading','Ply Matching','Cutting Accuracy','Colour','Fabric Hand Feel','Others'],
  'Sewing':    ['Thread / Seam','Stitch / S.P.I.','Elastic / Velcro','Btn Holes / Key Holes','EMB / Printing','Pocketing / Eyelet','Label & Position','Bottom / Hem','Bartacking','Lining / Drawcord','Others'],
  'Finishing': ['Washing','Shade','Thread Cut','Cleaning','Button / Rivet','Pressing','Measurement','Shade Check','SKU Checking','Others'],
  'Packing':   ['Folding Approval','Multi Pack','Solid Pack','Hanger','Price Ticketing','Hangtags etc.','Polybag','Carton','Poly / Barcode Sticker','Shipping Mark','Others'],
  'Safety & Critical Check': ['Needle Control','Sharp Tools Control','Lockstitch Button','Pull Testing','Needle Detector Passing','Nickel Testing','Garments Testing','Fire Warning Label','Zipper Check','Others'],
};

export const INSP_STYLING_CHECKS = ['PS','WS','Extr-Test','Inter-Test','Visual Check','Measurement','LBL','Sample Pick'];

export const MOISTURE_LIMITS = {
  Cotton:'8%', Nylon:'4%', Polyester:'0.04%', Viscose:'12.30%', Wool:'16%', Carton:'6 to 8%',
};

export const AQL_LEVELS = ['1.0','1.5','2.5','4.0','6.5'];

// Simplified single-sampling AQL acceptance table (General Inspection Level II).
// lot range → sample size, then accept counts per AQL.
export const AQL_TABLE = [
  { max:8,     n:2,   acc:{ '1.0':0, '1.5':0, '2.5':0, '4.0':0, '6.5':0 } },
  { max:15,    n:3,   acc:{ '1.0':0, '1.5':0, '2.5':0, '4.0':0, '6.5':1 } },
  { max:25,    n:5,   acc:{ '1.0':0, '1.5':0, '2.5':0, '4.0':1, '6.5':1 } },
  { max:50,    n:8,   acc:{ '1.0':0, '1.5':0, '2.5':1, '4.0':1, '6.5':2 } },
  { max:90,    n:13,  acc:{ '1.0':0, '1.5':1, '2.5':1, '4.0':2, '6.5':3 } },
  { max:150,   n:20,  acc:{ '1.0':1, '1.5':1, '2.5':2, '4.0':3, '6.5':5 } },
  { max:280,   n:32,  acc:{ '1.0':1, '1.5':2, '2.5':3, '4.0':5, '6.5':7 } },
  { max:500,   n:50,  acc:{ '1.0':2, '1.5':3, '2.5':5, '4.0':7, '6.5':10 } },
  { max:1200,  n:80,  acc:{ '1.0':3, '1.5':5, '2.5':7, '4.0':10, '6.5':14 } },
  { max:3200,  n:125, acc:{ '1.0':5, '1.5':7, '2.5':10, '4.0':14, '6.5':21 } },
  { max:10000, n:200, acc:{ '1.0':7, '1.5':10, '2.5':14, '4.0':21, '6.5':21 } },
  { max:35000, n:315, acc:{ '1.0':10, '1.5':14, '2.5':21, '4.0':21, '6.5':21 } },
  { max:150000,n:500, acc:{ '1.0':14, '1.5':21, '2.5':21, '4.0':21, '6.5':21 } },
  { max:Infinity, n:800, acc:{ '1.0':21, '1.5':21, '2.5':21, '4.0':21, '6.5':21 } },
];

export const aqlPlan = (lotSize, aql) => {
  const row = AQL_TABLE.find(r => lotSize <= r.max) || AQL_TABLE[AQL_TABLE.length-1];
  const accept = row.acc[aql] ?? row.acc['2.5'];
  return { sampleSize: row.n, accept, reject: accept + 1 };
};

// ─────────────────────────────────────────────────────────────────
//  J-05 · FMEA
// ─────────────────────────────────────────────────────────────────
export const FMEA_COLS = [
  { label:'Section',                 key:'section', width:'110px' },
  { label:'Process Step',            key:'processStep', type:'textarea', width:'130px' },
  { label:'Potential Failure Mode',  key:'failureMode', type:'textarea', width:'140px' },
  { label:'Potential Failure Effect',key:'failureEffect', type:'textarea', width:'140px' },
  { label:'Sev', key:'severity',    type:'number', width:'55px' },
  { label:'Potential Causes',        key:'causes', type:'textarea', width:'140px' },
  { label:'Occ', key:'occurrence',  type:'number', width:'55px' },
  { label:'Current Process Control', key:'control', type:'textarea', width:'150px' },
  { label:'Det', key:'detection',   type:'number', width:'55px' },
  { label:'Action Recommended',      key:'actionRecommended', type:'textarea', width:'160px' },
  { label:'Person Responsible',      key:'responsible', width:'120px' },
  { label:'Target Completion',       key:'targetDate', type:'date', width:'110px' },
  { label:'Action Results',          key:'actionResults', type:'textarea', width:'140px' },
];

export const FMEA_GUIDE = {
  severity:   'How severe is the effect on the customer? (1 = none, 10 = hazardous without warning)',
  occurrence: 'How frequently is the cause likely to occur? (1 = remote, 10 = very high)',
  detection:  'How likely will the control detect the failure? (1 = almost certain, 10 = absolutely uncertain)',
};
export const rpn = (r) => (parseFloat(r.severity)||0) * (parseFloat(r.occurrence)||0) * (parseFloat(r.detection)||0);
export const rpnColor = (v) => v >= 100 ? '#e2445c' : v >= 50 ? '#fdab3d' : v > 0 ? '#00c875' : '#676879';

// ═══════════════════════════════════════════════════════════════════
//  MEASUREMENT SPEC SHEET SCHEMA
//  Standard garment measurement points with tolerance defaults.
//  QA fills in spec value (from buyer spec sheet) + actuals per size.
// ═══════════════════════════════════════════════════════════════════

// Standard measurement points — QA can add/remove per style
export const STD_MEASUREMENT_POINTS = [
  { point:'Chest / Bust', tolerance:1.0 },
  { point:'Across Shoulder', tolerance:0.5 },
  { point:'Across Front Shoulder', tolerance:0.5 },
  { point:'Across Back Shoulder', tolerance:0.5 },
  { point:'Sleeve Length (from CB)', tolerance:1.0 },
  { point:'Sleeve Length (from shoulder)', tolerance:1.0 },
  { point:'Sleeve Opening / Cuff', tolerance:0.5 },
  { point:'Armhole', tolerance:0.5 },
  { point:'Body Length (CB)', tolerance:1.0 },
  { point:'Body Length (CF)', tolerance:1.0 },
  { point:'Waist', tolerance:1.0 },
  { point:'Hip', tolerance:1.0 },
  { point:'Inseam', tolerance:1.0 },
  { point:'Outseam', tolerance:1.0 },
  { point:'Thigh', tolerance:1.0 },
  { point:'Knee', tolerance:0.5 },
  { point:'Front Rise', tolerance:0.5 },
  { point:'Back Rise', tolerance:0.5 },
  { point:'Leg Opening', tolerance:0.5 },
  { point:'Neck Opening', tolerance:0.5 },
  { point:'Collar Height (CB)', tolerance:0.3 },
  { point:'Pocket Width', tolerance:0.3 },
  { point:'Pocket Depth', tolerance:0.3 },
  { point:'Placket Width', tolerance:0.3 },
  { point:'Placket Length', tolerance:0.5 },
];

export const MEAS_RESULT_OPTIONS = ['Pass','Fail','N/A'];
